// Copyright (c) 2017 Deere & Company

export const isClaimUserSelected = (claimNumber, auditClaims) =>
    auditClaims.findIndex(auditClaim =>
        (auditClaim.claimNumber === claimNumber) && !auditClaim.isSystemSelected
    ) !== -1;

export const isClaimSystemSelected = (claimNumber, auditClaims) =>
    auditClaims.findIndex(auditClaim =>
        (auditClaim.claimNumber === claimNumber) && auditClaim.isSystemSelected
    ) !== -1;



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/services/is-claim-in-audit.js